import { useRouter } from 'next/router';
import { useState } from 'react';
import type { LmsFilters } from '@/interfaces/lms';
import { convertFiltersToQueryParams, convertQueryParamsToFilters } from '@/lib/utils/lmsQueryParams';

export const useLmsFilters = () => {
    const router = useRouter();

    // @ts-ignore
    const sanitizedFilters: LmsFilters = convertQueryParamsToFilters(new URLSearchParams(router.query));

    const [filters, setFilters] = useState<LmsFilters>(sanitizedFilters);

    const updateFilters = (key: string, value: unknown | undefined) => {
        const updatedFilters: LmsFilters = { ...filters, [key]: value };

        setFilters(updatedFilters);

        router.push({ pathname: router.pathname, query: convertFiltersToQueryParams(updatedFilters) }, undefined, {
            shallow: true,
            scroll: false,
        });
    };

    const resetFilters = () => {
        setFilters({});
        router.push({ pathname: router.pathname, query: {} }, undefined, { shallow: true, scroll: false });
    };

    return {
        filters,
        updateFilters,
        resetFilters,
    };
};
